<template lang="">
  <div>
    <!-- Modal -->
    <div class="text-[13px]">
      <h2 class="text-black font-bold text-2xl mb-3">Download Brochure</h2>
      <div>
        <form
          class="space-y-3 p-4 font-normal"
          @submit="$emit('closeWidget')"
          @submit.prevent="enquireSubmit"
        >
          <input
            type="text"
            placeholder="Enter Name *"
            id="name"
            class="p-2 rounded-md w-full border border-[#ccc]"
            required
          />
          <input
            type="email"
            placeholder="Enter Email Address *"
            id="email"
            class="p-2 rounded-md w-full border border-[#ccc]"
            required
          />
          <input
            type="tel"
            placeholder="Enter Mobile Number *"
            id="phone"
            maxlength="10"
            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
            class="p-2 rounded-md w-full border border-[#ccc]"
            required
          />
          <div class="flex gap-4 text-xs items-start text-left text-black">
            <input type="checkbox" checked />
            <span class="text-justify"
              >I authorize Vignan Online and its associates to contact me with
              updates & notifications via email, SMS, WhatsApp, and voice call.
              This consent will override any registration for DNC/NDNC.</span
            >
          </div>
          <button
            type="submit"
            class="w-full text-white font-semibold bg-[#d02829] hover:bg-[#ca9216] rounded-lg px-4 py-2 text-center"
          >
            Download Brochure
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "BrochureView",

  props: ["widget_prop_id"],

  data: () => ({
    showForm: true,
    utmSource: "",
    utmSourceCampaign: "",
    utmSourceMedium: "",
    utmAdgroupid: "",
    utmCampaignid: "",
    utmCreativeid: "",
    utmDevice: "",
    utmKeyword: "",
    utmMatchtype: "",
    utmNetwork: "",
    utmPlacement: "",
    activeTab: "tab-1",
    selectedProgram: "",
    electiveOptions: [],
  }),

  created() {
    this.widget_id = this.widget_prop_id;
    this.utmSource = this.$route.query.utm_source || "Organic Search";
    this.utmSourceCampaign = this.$route.query.utm_campaign || "website";
    this.utmSourceMedium = this.$route.query.utm_medium || "";
    this.utmAdgroupid = this.$route.query.utm_adgroupid || "";
    this.utmCampaignid = this.$route.query.utm_campaignid || "";
    this.utmCreativeid = this.$route.query.utm_creativeid || "";
    this.utmDevice = this.$route.query.utm_device || "";
    this.utmKeyword = this.$route.query.utm_keyword || "";
    this.utmMatchtype = this.$route.query.utm_matchtype || "";
    this.utmNetwork = this.$route.query.utm_network || "";
    this.utmPlacement = this.$route.query.utm_placement || "";
  },

  methods: {
    enquireSubmit(el) {
      const form = el.target;

      const payload = {
        phone: form.elements.phone.value,
        name: form.elements.name.value,
        email: form.elements.email.value,
        university: "vgu",
        utmData: {
          utmSource: this.utmSource,
          utmMedium: this.utmSourceMedium,
          utmCampaign: this.utmSourceCampaign,
          utmAdgroupId: this.utmAdgroupid,
          utmCreativeId: this.utmCreativeid,
          utmDevice: this.utmDevice,
          utmNetwork: this.utmNetwork,
          utmCampaignId: this.utmCampaignid,
          utmMatchType: this.utmMatchtype,
          utmKeyword: this.utmKeyword,
          utmPlacement: this.utmPlacement,
          utmURL: window.location.href,
        },
      };

      console.log(payload);

      axios
        .post(`${process.env.VUE_APP_LEAD_API}/lead/register/`, payload)
        .then(async (resp) => {
          console.log(resp, "Response from API");

          form.reset();

          await fetch(
            "https://api.vignanonline.com/media/elective/brochures/VO_Overall_brochure.pdf"
          )
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "VO-Overall-brochure.pdf";
              a.click();
            });
        })
        .catch((error) => {
          console.error("Submission Error:", error.response || error);
        });
    },
  },
};
</script>

<style lang=""></style>
